export default __webpack_public_path__ + "static/media/banner3.36ffef27.png";